// extracted by mini-css-extract-plugin
export var item = "Bars-module--item--y8L-f";
export var item__icon = "Bars-module--item__icon--dPkyu";
export var item__image = "Bars-module--item__image--VJ9wx";
export var item__location = "Bars-module--item__location--q-gGZ";
export var item__name = "Bars-module--item__name--Skn+v";
export var item__overlay = "Bars-module--item__overlay--WQ+6b";
export var wrapper = "Bars-module--wrapper--k0Jz4";